import _get from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _construct from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/construct.js";
import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-use-before-define */

/**
 * Base class for inheritance.
 */
export var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);
  }

  _createClass(Base, [{
    key: "mixIn",
    value:
    /**
     * Copies properties into this object.
     *
     * @param {Object} properties The properties to mix in.
     *
     * @example
     *
     *     MyType.mixIn({
     *         field: 'value'
     *     });
     */
    function mixIn(properties) {
      return Object.assign(this, properties);
    }
    /**
     * Creates a copy of this object.
     *
     * @return {Object} The clone.
     *
     * @example
     *
     *     var clone = instance.clone();
     */

  }, {
    key: "clone",
    value: function clone() {
      var clone = new this.constructor();
      Object.assign(clone, this);
      return clone;
    }
  }], [{
    key: "create",
    value:
    /**
     * Extends this object and runs the init method.
     * Arguments to create() will be passed to init().
     *
     * @return {Object} The new object.
     *
     * @static
     *
     * @example
     *
     *     var instance = MyType.create();
     */
    function create() {
      for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _construct(this, args);
    }
  }]);

  return Base;
}();
/**
 * An array of 32-bit words.
 *
 * @property {Array} words The array of 32-bit words.
 * @property {number} sigBytes The number of significant bytes in this word array.
 */

export var WordArray = /*#__PURE__*/function (_Base) {
  _inherits(WordArray, _Base);

  var _super = _createSuper(WordArray);

  /**
   * Initializes a newly created word array.
   *
   * @param {Array} words (Optional) An array of 32-bit words.
   * @param {number} sigBytes (Optional) The number of significant bytes in the words.
   *
   * @example
   *
   *     var wordArray = CryptoJS.lib.WordArray.create();
   *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
   *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
   */
  function WordArray() {
    var _this;

    var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sigBytes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : words.length * 4;

    _classCallCheck(this, WordArray);

    _this = _super.call(this);
    var typedArray = words; // Convert buffers to uint8

    if (typedArray instanceof ArrayBuffer) {
      typedArray = new Uint8Array(typedArray);
    } // Convert other array views to uint8


    if (typedArray instanceof Int8Array || typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
      typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    } // Handle Uint8Array


    if (typedArray instanceof Uint8Array) {
      // Shortcut
      var typedArrayByteLength = typedArray.byteLength; // Extract bytes

      var _words = [];

      for (var i = 0; i < typedArrayByteLength; i += 1) {
        _words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
      } // Initialize this word array


      _this.words = _words;
      _this.sigBytes = typedArrayByteLength;
    } else {
      // Else call normal init
      _this.words = words;
      _this.sigBytes = sigBytes;
    }

    return _this;
  }
  /**
   * Creates a word array filled with random bytes.
   *
   * @param {number} nBytes The number of random bytes to generate.
   *
   * @return {WordArray} The random word array.
   *
   * @static
   *
   * @example
   *
   *     var wordArray = CryptoJS.lib.WordArray.random(16);
   */


  _createClass(WordArray, [{
    key: "toString",
    value:
    /**
     * Converts this word array to a string.
     *
     * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
     *
     * @return {string} The stringified word array.
     *
     * @example
     *
     *     var string = wordArray + '';
     *     var string = wordArray.toString();
     *     var string = wordArray.toString(CryptoJS.enc.Utf8);
     */
    function toString() {
      var encoder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Hex;
      return encoder.stringify(this);
    }
    /**
     * Concatenates a word array to this word array.
     *
     * @param {WordArray} wordArray The word array to append.
     *
     * @return {WordArray} This word array.
     *
     * @example
     *
     *     wordArray1.concat(wordArray2);
     */

  }, {
    key: "concat",
    value: function concat(wordArray) {
      // Shortcuts
      var thisWords = this.words;
      var thatWords = wordArray.words;
      var thisSigBytes = this.sigBytes;
      var thatSigBytes = wordArray.sigBytes; // Clamp excess bits

      this.clamp(); // Concat

      if (thisSigBytes % 4) {
        // Copy one byte at a time
        for (var i = 0; i < thatSigBytes; i += 1) {
          var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
          thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
        }
      } else {
        // Copy one word at a time
        for (var _i = 0; _i < thatSigBytes; _i += 4) {
          thisWords[thisSigBytes + _i >>> 2] = thatWords[_i >>> 2];
        }
      }

      this.sigBytes += thatSigBytes; // Chainable

      return this;
    }
    /**
     * Removes insignificant bits.
     *
     * @example
     *
     *     wordArray.clamp();
     */

  }, {
    key: "clamp",
    value: function clamp() {
      // Shortcuts
      var words = this.words,
          sigBytes = this.sigBytes; // Clamp

      words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
      words.length = Math.ceil(sigBytes / 4);
    }
    /**
     * Creates a copy of this word array.
     *
     * @return {WordArray} The clone.
     *
     * @example
     *
     *     var clone = wordArray.clone();
     */

  }, {
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(WordArray.prototype), "clone", this).call(this);

      clone.words = this.words.slice(0);
      return clone;
    }
  }], [{
    key: "random",
    value: function random(nBytes) {
      var words = [];

      var r = function r(m_w) {
        var _m_w = m_w;
        var _m_z = 0x3ade68b1;
        var mask = 0xffffffff;
        return function () {
          _m_z = 0x9069 * (_m_z & 0xFFFF) + (_m_z >> 0x10) & mask;
          _m_w = 0x4650 * (_m_w & 0xFFFF) + (_m_w >> 0x10) & mask;
          var result = (_m_z << 0x10) + _m_w & mask;
          result /= 0x100000000;
          result += 0.5;
          return result * (Math.random() > 0.5 ? 1 : -1);
        };
      };

      for (var i = 0, rcache; i < nBytes; i += 4) {
        var _r = r((rcache || Math.random()) * 0x100000000);

        rcache = _r() * 0x3ade67b7;
        words.push(_r() * 0x100000000 | 0);
      }

      return new WordArray(words, nBytes);
    }
  }]);

  return WordArray;
}(Base);
/**
 * Hex encoding strategy.
 */

export var Hex = {
  /**
   * Converts a word array to a hex string.
   *
   * @param {WordArray} wordArray The word array.
   *
   * @return {string} The hex string.
   *
   * @static
   *
   * @example
   *
   *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
   */
  stringify: function stringify(wordArray) {
    // Shortcuts
    var words = wordArray.words,
        sigBytes = wordArray.sigBytes; // Convert

    var hexChars = [];

    for (var i = 0; i < sigBytes; i += 1) {
      var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
      hexChars.push((bite >>> 4).toString(16));
      hexChars.push((bite & 0x0f).toString(16));
    }

    return hexChars.join('');
  },

  /**
   * Converts a hex string to a word array.
   *
   * @param {string} hexStr The hex string.
   *
   * @return {WordArray} The word array.
   *
   * @static
   *
   * @example
   *
   *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
   */
  parse: function parse(hexStr) {
    // Shortcut
    var hexStrLength = hexStr.length; // Convert

    var words = [];

    for (var i = 0; i < hexStrLength; i += 2) {
      words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
    }

    return new WordArray(words, hexStrLength / 2);
  }
};
/**
 * Latin1 encoding strategy.
 */

export var Latin1 = {
  /**
   * Converts a word array to a Latin1 string.
   *
   * @param {WordArray} wordArray The word array.
   *
   * @return {string} The Latin1 string.
   *
   * @static
   *
   * @example
   *
   *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
   */
  stringify: function stringify(wordArray) {
    // Shortcuts
    var words = wordArray.words,
        sigBytes = wordArray.sigBytes; // Convert

    var latin1Chars = [];

    for (var i = 0; i < sigBytes; i += 1) {
      var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
      latin1Chars.push(String.fromCharCode(bite));
    }

    return latin1Chars.join('');
  },

  /**
   * Converts a Latin1 string to a word array.
   *
   * @param {string} latin1Str The Latin1 string.
   *
   * @return {WordArray} The word array.
   *
   * @static
   *
   * @example
   *
   *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
   */
  parse: function parse(latin1Str) {
    // Shortcut
    var latin1StrLength = latin1Str.length; // Convert

    var words = [];

    for (var i = 0; i < latin1StrLength; i += 1) {
      words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
    }

    return new WordArray(words, latin1StrLength);
  }
};
/**
 * UTF-8 encoding strategy.
 */

export var Utf8 = {
  /**
   * Converts a word array to a UTF-8 string.
   *
   * @param {WordArray} wordArray The word array.
   *
   * @return {string} The UTF-8 string.
   *
   * @static
   *
   * @example
   *
   *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
   */
  stringify: function stringify(wordArray) {
    try {
      return decodeURIComponent(escape(Latin1.stringify(wordArray)));
    } catch (e) {
      throw new Error('Malformed UTF-8 data');
    }
  },

  /**
   * Converts a UTF-8 string to a word array.
   *
   * @param {string} utf8Str The UTF-8 string.
   *
   * @return {WordArray} The word array.
   *
   * @static
   *
   * @example
   *
   *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
   */
  parse: function parse(utf8Str) {
    return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
  }
};
/**
 * Abstract buffered block algorithm template.
 *
 * The property blockSize must be implemented in a concrete subtype.
 *
 * @property {number} _minBufferSize
 *
 *     The number of blocks that should be kept unprocessed in the buffer. Default: 0
 */

export var BufferedBlockAlgorithm = /*#__PURE__*/function (_Base2) {
  _inherits(BufferedBlockAlgorithm, _Base2);

  var _super2 = _createSuper(BufferedBlockAlgorithm);

  function BufferedBlockAlgorithm() {
    var _this2;

    _classCallCheck(this, BufferedBlockAlgorithm);

    _this2 = _super2.call(this);
    _this2._minBufferSize = 0;
    return _this2;
  }
  /**
   * Resets this block algorithm's data buffer to its initial state.
   *
   * @example
   *
   *     bufferedBlockAlgorithm.reset();
   */


  _createClass(BufferedBlockAlgorithm, [{
    key: "reset",
    value: function reset() {
      // Initial values
      this._data = new WordArray();
      this._nDataBytes = 0;
    }
    /**
     * Adds new data to this block algorithm's buffer.
     *
     * @param {WordArray|string} data
     *
     *     The data to append. Strings are converted to a WordArray using UTF-8.
     *
     * @example
     *
     *     bufferedBlockAlgorithm._append('data');
     *     bufferedBlockAlgorithm._append(wordArray);
     */

  }, {
    key: "_append",
    value: function _append(data) {
      var m_data = data; // Convert string to WordArray, else assume WordArray already

      if (typeof m_data === 'string') {
        m_data = Utf8.parse(m_data);
      } // Append


      this._data.concat(m_data);

      this._nDataBytes += m_data.sigBytes;
    }
    /**
     * Processes available data blocks.
     *
     * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
     *
     * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
     *
     * @return {WordArray} The processed data.
     *
     * @example
     *
     *     var processedData = bufferedBlockAlgorithm._process();
     *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
     */

  }, {
    key: "_process",
    value: function _process(doFlush) {
      var processedWords; // Shortcuts

      var data = this._data,
          blockSize = this.blockSize;
      var dataWords = data.words;
      var dataSigBytes = data.sigBytes;
      var blockSizeBytes = blockSize * 4; // Count blocks ready

      var nBlocksReady = dataSigBytes / blockSizeBytes;

      if (doFlush) {
        // Round up to include partial blocks
        nBlocksReady = Math.ceil(nBlocksReady);
      } else {
        // Round down to include only full blocks,
        // less the number of blocks that must remain in the buffer
        nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
      } // Count words ready


      var nWordsReady = nBlocksReady * blockSize; // Count bytes ready

      var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes); // Process blocks

      if (nWordsReady) {
        for (var offset = 0; offset < nWordsReady; offset += blockSize) {
          // Perform concrete-algorithm logic
          this._doProcessBlock(dataWords, offset);
        } // Remove processed words


        processedWords = dataWords.splice(0, nWordsReady);
        data.sigBytes -= nBytesReady;
      } // Return processed words


      return new WordArray(processedWords, nBytesReady);
    }
    /**
     * Creates a copy of this object.
     *
     * @return {Object} The clone.
     *
     * @example
     *
     *     var clone = bufferedBlockAlgorithm.clone();
     */

  }, {
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(BufferedBlockAlgorithm.prototype), "clone", this).call(this);

      clone._data = this._data.clone();
      return clone;
    }
  }]);

  return BufferedBlockAlgorithm;
}(Base);
/**
 * Abstract hasher template.
 *
 * @property {number} blockSize
 *
 *     The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
 */

export var Hasher = /*#__PURE__*/function (_BufferedBlockAlgorit) {
  _inherits(Hasher, _BufferedBlockAlgorit);

  var _super3 = _createSuper(Hasher);

  function Hasher(cfg) {
    var _this3;

    _classCallCheck(this, Hasher);

    _this3 = _super3.call(this);
    _this3.blockSize = 512 / 32;
    /**
     * Configuration options.
     */

    _this3.cfg = Object.assign(new Base(), cfg); // Set initial values

    _this3.reset();

    return _this3;
  }
  /**
   * Creates a shortcut function to a hasher's object interface.
   *
   * @param {Hasher} SubHasher The hasher to create a helper for.
   *
   * @return {Function} The shortcut function.
   *
   * @static
   *
   * @example
   *
   *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
   */


  _createClass(Hasher, [{
    key: "reset",
    value:
    /**
     * Resets this hasher to its initial state.
     *
     * @example
     *
     *     hasher.reset();
     */
    function reset() {
      // Reset data buffer
      _get(_getPrototypeOf(Hasher.prototype), "reset", this).call(this); // Perform concrete-hasher logic


      this._doReset();
    }
    /**
     * Updates this hasher with a message.
     *
     * @param {WordArray|string} messageUpdate The message to append.
     *
     * @return {Hasher} This hasher.
     *
     * @example
     *
     *     hasher.update('message');
     *     hasher.update(wordArray);
     */

  }, {
    key: "update",
    value: function update(messageUpdate) {
      // Append
      this._append(messageUpdate); // Update the hash


      this._process(); // Chainable


      return this;
    }
    /**
     * Finalizes the hash computation.
     * Note that the finalize operation is effectively a destructive, read-once operation.
     *
     * @param {WordArray|string} messageUpdate (Optional) A final message update.
     *
     * @return {WordArray} The hash.
     *
     * @example
     *
     *     var hash = hasher.finalize();
     *     var hash = hasher.finalize('message');
     *     var hash = hasher.finalize(wordArray);
     */

  }, {
    key: "finalize",
    value: function finalize(messageUpdate) {
      // Final message update
      if (messageUpdate) {
        this._append(messageUpdate);
      } // Perform concrete-hasher logic


      var hash = this._doFinalize();

      return hash;
    }
  }], [{
    key: "_createHelper",
    value: function _createHelper(SubHasher) {
      return function (message, cfg) {
        return new SubHasher(cfg).finalize(message);
      };
    }
    /**
     * Creates a shortcut function to the HMAC's object interface.
     *
     * @param {Hasher} SubHasher The hasher to use in this HMAC helper.
     *
     * @return {Function} The shortcut function.
     *
     * @static
     *
     * @example
     *
     *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
     */

  }, {
    key: "_createHmacHelper",
    value: function _createHmacHelper(SubHasher) {
      return function (message, key) {
        return new HMAC(SubHasher, key).finalize(message);
      };
    }
  }]);

  return Hasher;
}(BufferedBlockAlgorithm);
/**
 * HMAC algorithm.
 */

export var HMAC = /*#__PURE__*/function (_Base3) {
  _inherits(HMAC, _Base3);

  var _super4 = _createSuper(HMAC);

  /**
   * Initializes a newly created HMAC.
   *
   * @param {Hasher} SubHasher The hash algorithm to use.
   * @param {WordArray|string} key The secret key.
   *
   * @example
   *
   *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
   */
  function HMAC(SubHasher, key) {
    var _this4;

    _classCallCheck(this, HMAC);

    _this4 = _super4.call(this);
    var hasher = new SubHasher();
    _this4._hasher = hasher; // Convert string to WordArray, else assume WordArray already

    var _key = key;

    if (typeof _key === 'string') {
      _key = Utf8.parse(_key);
    } // Shortcuts


    var hasherBlockSize = hasher.blockSize;
    var hasherBlockSizeBytes = hasherBlockSize * 4; // Allow arbitrary length keys

    if (_key.sigBytes > hasherBlockSizeBytes) {
      _key = hasher.finalize(key);
    } // Clamp excess bits


    _key.clamp(); // Clone key for inner and outer pads


    var oKey = _key.clone();

    _this4._oKey = oKey;

    var iKey = _key.clone();

    _this4._iKey = iKey; // Shortcuts

    var oKeyWords = oKey.words;
    var iKeyWords = iKey.words; // XOR keys with pad constants

    for (var i = 0; i < hasherBlockSize; i += 1) {
      oKeyWords[i] ^= 0x5c5c5c5c;
      iKeyWords[i] ^= 0x36363636;
    }

    oKey.sigBytes = hasherBlockSizeBytes;
    iKey.sigBytes = hasherBlockSizeBytes; // Set initial values

    _this4.reset();

    return _this4;
  }
  /**
   * Resets this HMAC to its initial state.
   *
   * @example
   *
   *     hmacHasher.reset();
   */


  _createClass(HMAC, [{
    key: "reset",
    value: function reset() {
      // Shortcut
      var hasher = this._hasher; // Reset

      hasher.reset();
      hasher.update(this._iKey);
    }
    /**
     * Updates this HMAC with a message.
     *
     * @param {WordArray|string} messageUpdate The message to append.
     *
     * @return {HMAC} This HMAC instance.
     *
     * @example
     *
     *     hmacHasher.update('message');
     *     hmacHasher.update(wordArray);
     */

  }, {
    key: "update",
    value: function update(messageUpdate) {
      this._hasher.update(messageUpdate); // Chainable


      return this;
    }
    /**
     * Finalizes the HMAC computation.
     * Note that the finalize operation is effectively a destructive, read-once operation.
     *
     * @param {WordArray|string} messageUpdate (Optional) A final message update.
     *
     * @return {WordArray} The HMAC.
     *
     * @example
     *
     *     var hmac = hmacHasher.finalize();
     *     var hmac = hmacHasher.finalize('message');
     *     var hmac = hmacHasher.finalize(wordArray);
     */

  }, {
    key: "finalize",
    value: function finalize(messageUpdate) {
      // Shortcut
      var hasher = this._hasher; // Compute HMAC

      var innerHash = hasher.finalize(messageUpdate);
      hasher.reset();
      var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
      return hmac;
    }
  }]);

  return HMAC;
}(Base);